import requests from "./httpService";

const ChatHistoryServices = {

  getAllChat: async (body) => {
    return requests.get("/getChatHistory/", body);
  },
  getChatByEmpId: async (id, body) => {
    return requests.post(`/getChatHistory/${id}`, body);
  },
  // The logged-in employee's own chats + rating summary (server decides who
  // from the login token). from/to as DD-MM-YYYY; default last 10 days.
  getMyChats: async (from, to) => {
    const q = from && to ? `?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}` : "";
    return requests.get(`/my-chats${q}`);
  },
  // Chats in progress right now (active/transferred), optionally for one employee.
  getLiveChats: async (employeeId) => {
    return requests.get(employeeId ? `/live?employee_id=${employeeId}` : `/live`);
  },
  // All messages of one chat, oldest first (GET /chat/:chat_id).
  getMessagesByChatId: async (chatId) => {
    return requests.get(`/${chatId}`);
  },

};

export default ChatHistoryServices;
